import { FieldDescribe } from 'app/backend/salesforce-maps/DescribeTypes'
import React from 'react'

interface FormEditorAvaliableObjects {
  isSelectable: boolean
  label: string
  name: string
  fields: FieldDescribe[]
  relatedCollections: any[]
  recordTypes: Record<string, any>
}

interface FormEditorContextType {
  availableObjects: FormEditorAvaliableObjects[]
}

const FormContext = React.createContext<FormEditorContextType>({
  availableObjects: []
})

export function useFormEditorContext (): FormEditorContextType {
  const value = React.useContext(FormContext)
  if (value == null) {
    throw new Error(
      'useFormEditorContext must be wrapped in a <SessionProvider />'
    )
  }
  return value
}

export function FormEditorContextProvider (
  props: React.PropsWithChildren<FormEditorContextType>
) {
  return (
    <FormContext.Provider
      value={{
        ...props
      }}
    >
      {props.children}
    </FormContext.Provider>
  )
}
